/**
 * Container component for displaying an image with 8x8 grid for motion grid
 *
 * @author: Vanessa Richie Alia-Trapero <vanessa@dividia.net>
 */

import { useEffect, useState } from 'react'
import MotionGridOverlay from './MotionGridOverlay'
import defaultImage from '../../../../player_poster.png'

const MotionGrid = (props) => {
  const {deviceId, bCamera, value, onChange} = props

  const hexToArr = (hex) => {
    // eslint-disable-next-line no-undef
    let hexBin = BigInt(hex) // convert value to big int
    let hexString = hexBin.toString(2).padStart(64, '0') // convert to binary string
    let hexArr = Array.from(hexString) // convert binary string to array
    return hexArr
  }

  const gridArr = hexToArr(value)
  const [grid, setGrid] = useState(gridArr)
  const [showGrid, setShowGrid] = useState(false)
  const [image, setImage] = useState('')
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)

  useEffect(() => {
    let url = new URL(process.env.REACT_APP_BACKEND)
    url.port = process.env.REACT_APP_RESOURCE_PORT
    const resourceUrl = url.toString()
    const imgUrl = `${resourceUrl}${deviceId}-cam${bCamera}.jpg`
    // const imgUrl = `http://web1.dividia.net:8888/00044BEACBBB-cam1.jpg` // current working example
    setImage(imgUrl)
  // eslint-disable-next-line
  }, [])

  const displayGrid = (e) => {
    e.preventDefault()
    setShowGrid(true)
  }

  const hideGrid = (e) => {
    // put focus back to config form before removing the motion grid UI so onBlur will work
    document.getElementById("config-form").focus()
    e.preventDefault()
    setShowGrid(false)
  }

  const clearGrid = (e) => {
    setGrid(gridArr)
    hideGrid(e)
  }

  const saveGrid = (e) => {
    const gridHex = arrToHex(grid)
    onChange(gridHex)
    hideGrid(e)
  }

  const arrToHex = (arr) => {
    const arrString = arr.join('') //convert array to binary string
    // eslint-disable-next-line no-undef
    const arrBin = BigInt('0b' + arrString) //convert binary to big int
    let arrHex = arrBin.toString(16).toUpperCase().padStart(16, '0') // convert big int to 16 character hex
    return '0x' + arrHex
  }

  const onLoad = () => {
    setLoading(false)
  }

  const onError = (e) => {
    setLoading(false)
    setError(true)
  }

  const toggleGridItem = (i) => {
    let newGrid = [...grid]
    newGrid[i] = newGrid[i] === '0' ? '1' : '0'
    setGrid(newGrid)
  }

  return (
    <>
      <button style={styles.formInputButton} onClick={displayGrid}>Edit</button>
      <div style={{justifyContent: 'center', display: showGrid ? 'block' : 'none' }}>
        <div style={styles.motionGrid}>
          <div style={styles.buttons}>
            {(loading || error)
              ? <button style={styles.button} onClick={clearGrid}>Close</button>
              : <>
                  <button style={styles.button} onClick={clearGrid}>Cancel</button>
                  <button style={styles.button} onClick={saveGrid}>Save</button>
                </>
            }
          </div>
          <div style={styles.imageContainer}>
            <img alt="" src={defaultImage} style={{...styles.image, display: (loading || error) ? 'block' : 'none'}}/>
            <img alt="" src={image} onLoad={onLoad} onError={onError} style={{...styles.image, height: (loading || error) ? 0 : 'auto'}}/>
            <MotionGridOverlay loading={loading} error={error} grid={grid} toggleGridItem={toggleGridItem} />
          </div>
        </div>
      </div>
    </>
  )
}

export default MotionGrid

const styles = {
  formInputButton: {
    width: '51%',
    fontSize: '1.6vmin',
    textAlign: 'left',
    cursor: 'pointer',
    paddingLeft: '1px',
  },
  motionGrid: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: '10px',
  },
  imageContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: "relative",
  },
  image: {
    border: '2px solid gray',
    maxWidth:'70vw',
    maxHeight:'60vh',
    width: '100%',
    height: 'auto',
  },
  buttons: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px'
  },
  button: {
    marginBottom: '2%',
    cursor: 'pointer',
    fontSize: '1.4vmin',
  }
}